const $ = require('jquery');
require('bootstrap-tooltip');

/*
 Hide elements that should only be shown for users with certain rights
 */
const tooltipWhitelistOverride = function tooltipWhitelistOverride() {
    const myDefaultWhiteList = $.fn.tooltip.Constructor.DEFAULTS.whiteList;

    // To allow dl/dt/dd elements
    const allowedElements = ['dl', 'dt', 'dd'];
    for (let i = 0; i < allowedElements.length; i += 1) {
        myDefaultWhiteList[allowedElements[i]] = [];
    }
};
module.exports = tooltipWhitelistOverride;
